<template>
  <div class="ScreenDark" />
</template>

<script>
export default {
  name: 'ScreenDark',
};
</script>
<style scoped>
.ScreenDark {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  background: transparent linear-gradient(180deg, #41565d66 0%, black 100%) 0%
    0% no-repeat padding-box;
  animation: screenDarkFadeIn 0.35s 1s linear backwards;
  z-index: 50;
}

@keyframes screenDarkFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
